import { Injectable } from '@angular/core';
import { Notification } from '@app/models/notification';
import { ApiService } from '@app/services/api/api.service';
import {
  AddAll,
  LoadFail,
  LoadSuccess,
  NotificationActionTypes,
  Update,
  UpdateFail,
  UpdateSuccess,
  UpdateOne
} from '@core/actions/notification.actions';
// import { Notifica } from '@core/actions/notification.actions';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { PortService } from '@app/services/api/port.service';
import { FlashService } from '@app/services/flash.service';
import { Router } from '@angular/router';

@Injectable()
export class NotificationEffects {
  @Effect()
  load$: Observable<Action> = this.actions$.pipe(
    ofType(NotificationActionTypes.Load),
    switchMap(() =>
      this.api.getNotifications().pipe(
        map((notifications: Notification[]) => new LoadSuccess(notifications)),
        catchError(error => of(new LoadFail(error)))
      )
    )
  );

  @Effect()
  loadSuccess$: Observable<Action> = this.actions$.pipe(
    ofType<LoadSuccess>(NotificationActionTypes.LoadSuccess),
    map(action => new AddAll(action.notifications))
  );

  @Effect()
  update$: Observable<Action> = this.actions$.pipe(
    ofType<Update>(NotificationActionTypes.Update),
    map(action => [action.id, action.notification]),
    switchMap(([id, data]) => {
      return this.api.updateNotification(id, data).pipe(
        map(notification => {
          this.fs.emit({
            type: 'success',
            message: 'Notificación actualizada'
          });
          return new UpdateSuccess(notification);
        }),
        catchError(error => of(new UpdateFail(error)))
      );
    })
  );

  // @Effect()
  // updateSuccess$: Observable<Action> = this.actions$.pipe(
  //   ofType<UpdateSuccess>(NotificationActionTypes.UpdateSuccess),
  //   map(action => {
  //     // this.router.navigate(['/notifications']);
  //     return new UpdateOne(action.data);
  //   })
  // );

  @Effect({ dispatch: false })
  updateFail$ = this.actions$.pipe(
    ofType<UpdateFail>(NotificationActionTypes.UpdateFail),
    map(action => action.error),
    tap(res =>
      this.fs.emit({
        message: 'Notificación no actualizada',
        type: 'danger'
      })
    )
  );

  constructor(
    private actions$: Actions,
    private api: ApiService,
    private fs: FlashService,
    private router: Router
  ) {}
}
